var exports = {
  "d": "x2b2fbebb--0b8de4--star",
  "h": "x2b2fbebb--0b8de4--input",
};

module.exports = exports;
